import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../../app/i18n";
import { PayPage } from "../../areas/public/pay/PayPage";

/** Pay page (FE-13): public, no session, no service worker. */
export const Route = createFileRoute("/pay/$token")({
  beforeLoad: () => loadNamespaces("pay"),
  component: PayRoute,
});

function PayRoute() {
  const { token } = Route.useParams();
  return <PayPage token={token} />;
}
